import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  const handleClick = (link: string) => {
    window.open(link, '_blank', 'noopener=yes,noreferrer=yes');
  };

  return (
    <section className="w-full bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-16 md:py-24">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300 text-xs font-semibold text-accent-700 bg-accent-50/60">
            Kategorie
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mt-5">
            {t('categories.title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            {t('categories.subtitle')}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => handleClick(cat.link)}
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300 hover:bg-accent-50/50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-accent-100/60 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all mb-4">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-accent-700 transition-colors whitespace-nowrap">
                {cat.namePl}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-400 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}